import { useState, useEffect } from "react"
// import { useRemoteState } from "nanoweb-react"
import { useRemoteState } from "../utils/remoteState"
import { Card, Button, Nav, Tab, Carousel } from "react-bootstrap"
import { LiaTimesSolid, LiaFacebookMessenger, LiaWhatsapp } from "react-icons/lia"

const nl2br = (text) => {
	return text.trim().split("\n").map((line, index) => (
		<span key={index}>
			{line}
			<br />
		</span>
	))
}

import PropTypes from 'prop-types';

const Slides = ({ items = [] }) => {
	return (
		<Carousel fade>
			{items.map((item, i) => (
				<Carousel.Item key={i}>
					<img src={item} className="w-100" />
				</Carousel.Item>
			))}
		</Carousel>
	)
}

const Assets = ({ hideHeader = false, onChat = () => 1, onCall = () => 1 }) => {
	/**
	 * @type {Record<string, Array<{ id: string, title: string, desc: string, btn: string }>>}
	 */
	const [ads] = useRemoteState("/ads.json", {})
	const [activeGroup, setActiveGroup] = useState(null)

	const useIsMobile = () => {
		const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 767px)").matches);

		useEffect(() => {
			const handler = () => setIsMobile(window.matchMedia("(max-width: 767px)").matches);
			window.addEventListener("resize", handler);
			return () => window.removeEventListener("resize", handler);
		}, []);

		return isMobile;
	};
	const groups = Object.keys(ads)

	// Set the first group as active by default
	if (!activeGroup && groups.length > 0) {
		setActiveGroup(groups[0])
	}

	const top = useIsMobile() ? 0 : 54

	return (
		<div className="assets mx-auto" style={{ maxWidth: '45rem' }}>
			{groups.length ? (
				<Tab.Container activeKey={activeGroup}>
					{/* Tab Navigation */}
					<Nav justify variant="tabs" className="mb-3 sticky-top bg-body" style={{ top }}>
						{groups.map((group) => (
							<Nav.Item key={group}>
								<Nav.Link
									eventKey={group}
									onClick={() => setActiveGroup(group)}
								>
									{group}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>

					{/* Ad List for Active Group */}
					<Tab.Content>
						<Tab.Pane eventKey={activeGroup}>
							<div className="d-flex flex-column align-items-center gap-4">
								{ads[activeGroup]?.length ? (
									ads[activeGroup].map((ad) => (
										<Card key={ad.id} className="shadow-sm">
											{!hideHeader && (
												<Card.Header className="d-flex gap-3">
												<figure className="rounded-circle border-1 bg-white p-2 mb-0" style={{ width: 'fit-content' }}>
													<img
														src="logo.svg"
														alt="Logo"
														style={{ width: "2rem", height: "2rem" }}
													/>
												</figure>
												<div>
													<div className="fs-6">{ad.title}</div>
													<div className="text-muted">Sponsored</div>
												</div>
												<div className="ms-auto">
													<Button variant="link" className="p-1">
														<LiaTimesSolid size={24} />
													</Button>
												</div>
												</Card.Header>
											)}
											<Card.Body className="d-flex flex-column align-items-start">
												<div>
													<Card.Text className="mb-0">{nl2br(ad.desc ?? "")}</Card.Text>
												</div>
											</Card.Body>
											{ad.slides && (
												<Slides items={ad.slides} />
											)}
											<Card.Footer className="d-flex justify-content-between align-items-center">
												<div>
													ATLAS USA
												</div>
												{ad.btn && (
													<a className='btn btn-sm btn-success d-inline-flex gap-1' href='https://wa.me/17328168899' onClick={onChat}>
														<span><LiaWhatsapp size={24} /></span>
														<span>{ad.btn}</span>
													</a>
												)}
											</Card.Footer>
										</Card>
									))
								) : (
									<p>No ads available for this group.</p>
								)}
							</div>
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			) : (
				<span>Loading...</span>
			)}
		</div>
	)
}

Assets.propTypes = {
	hideHeader: PropTypes.bool,
	onCall: PropTypes.func,
	onChat: PropTypes.func,
}


Slides.propTypes = {
	items: PropTypes.arrayOf(PropTypes.string)
}

export default Assets
